import { useState, useEffect } from 'react';
import './index.css';
import ProdutoDetailsModal from 'components/ProdutosDetails.Modal';
import ProdutoCreatorModal from 'components/ProdutosCreator.Modal'
import InputFinder from 'components/inputFinder';

function Card({ getList, produtos, produtosMemoria, setHunterVisibilitie, hunterVisible, setCreatorModal, creatorModal }) {
	const [ListaDeProdutos, setListaDeProdutos] = useState([]);
	useEffect(() => {
		setListaDeProdutos([...produtos]);
	}, [produtos]);

	const [produtoSelecionado, setProdutoSelecionado] = useState({});
	const [produtoModal, setProdutoModal] = useState(false);
	const addProduto = (i) => {
		const p = {
			[i]: Number(produtoSelecionado[i] || 0) + 1,
		};
		setProdutoSelecionado({ ...produtoSelecionado, ...p });
	};
	const delProduto = (i) => {
		const p = {
			[i]: Number(produtoSelecionado[i] || 0) - 1,
		};
		setProdutoSelecionado({ ...produtoSelecionado, ...p });
	};
	const trash = (r) => {
		if (r === 1) {
			return '🗑';
		} else {
			return '➖';
		}
	};
	const delBtn = (r, i) =>
		Boolean(r) && (
			<>
				<button
					className='ProdutoListaItem__Button'
					onClick={(e) => {
						e.stopPropagation();
						delProduto(i);
					}}
				>
					{trash(produtoSelecionado[i])}
				</button>
				<span className='ProdutoListaItem__Button ProdutoListaItem__Button__number'>{produtoSelecionado[i]}</span>
				<button
					className='ProdutoListaItem__Button'
					onClick={(e) => {
						e.stopPropagation();
						addProduto(i);
					}}
				>
					➕
				</button>
			</>
		);
	const adcBtn = (r, i) =>
		Boolean(!r) && (
			<button
				className='ProdutoListaItem__Button ProdutoListaItem__Button__full'
				onClick={(e) => {
					e.stopPropagation();
					addProduto(i);
				}}
			>
				Adicionar
			</button>
		);
	const foto = (p) => {
		const ft = produtosMemoria.find((e) => e.produto === p.produto);
		if (ft) return ft.foto;
	};

	return (
		<main className='ProdutoLista'>
			{ListaDeProdutos.map((p, i) => (
				<div
					className='ProdutoListaItem'
					key={`ProdutoListaItem__${i}`}
					onClick={(e) => {
						e.stopPropagation();
						setProdutoModal(p);
					}}
				>
					<div>
						<h2> {p.produto} </h2>
						<p> {p.descricao} </p>
						<div>
							<div>
								{delBtn(produtoSelecionado[i], i)}
								{adcBtn(produtoSelecionado[i], i)}
							</div>
							<span> R$ {p.preco} </span>
						</div>
					</div>
					{/* <img className='ProdutoListaItem__foto' src={produtosMemoria[i].foto} alt={p.produto} /> */}
					<img className='ProdutoListaItem__foto' src={foto(p)} alt={p.produto} />
				</div>
			))}
			{produtoModal && <ProdutoDetailsModal getList={getList} produto={produtoModal} closeModal={() => setProdutoModal(false)} />}
			{creatorModal && <ProdutoCreatorModal getList={getList} closeModal={() => setCreatorModal(false)} />}
			{Boolean(hunterVisible) && <InputFinder produtos={produtos} closeModal={() => setHunterVisibilitie(false)} />}
		</main>
	);
}

export default Card;
